import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=d5c36a54&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=d5c36a54&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c36a54",
  null
  
)

export default component.exports